import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

// The same card on a phone - which is what actually scans a QR. The layout is
// already one column, so it only loses the desktop width.
export default function GuestCardMobile({ vm }) {
  const { loading, error, guest, fullName, event, functions } = vm;

  return (
    <div className="gcard-page gcard-m">
      <div className="gcard">
        {loading ? <Spinner /> : error ? (
          <div className="gcard-error">{error}</div>
        ) : (
          <>
            <div className="gcard-event">{event?.EventName}</div>
            <h1 className="gcard-name">{fullName || guest?.CardName || 'Guest'}</h1>
            <div className="gcard-sub">
              {[guest?.City, guest?.MobileNumber, Number(guest?.ExpectedCount || 1) > 1 ? `${guest.ExpectedCount} persons` : '']
                .filter(Boolean).join(' · ')}
            </div>

            <div className="gcard-label">Invited to</div>
            {functions.length === 0 && <div className="muted">No functions on this invitation.</div>}
            <ul className="gcard-fns">
              {functions.map(f => (
                <li key={f.FunctionId}>
                  <strong>{f.FunctionName}</strong>
                  <span>{fmtDate(f.FunctionDate)}{f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}</span>
                  {(f.Venue || f.VenueAddress) && (
                    <span className="muted">{[f.Venue, f.VenueAddress, f.City].filter(Boolean).join(', ')}</span>
                  )}
                  {f.GpsLocation && <a href={f.GpsLocation} target="_blank" rel="noreferrer">Open the map</a>}
                </li>
              ))}
            </ul>
            <div className="gcard-foot muted">Mehfil by Smartify</div>
          </>
        )}
      </div>
    </div>
  );
}
